import ACLStore from "lib/aclStore";
import { CALENDAR_2_FEATURE_FLAG } from "./constants";

export const getIsCalendar2Enabled = () =>
  ACLStore.can(CALENDAR_2_FEATURE_FLAG);
